import { instance } from "./axios";

export const getRegions = () => {
    try {
        return instance.get("/regions");
    } catch (error) {
        throw error;
    }
};